<template>
  <el-card class="main-card pending-return-detail">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/stock/bills/pendingReturn' }">待回货管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ id ? '详情' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-alert v-if="isReturnBill" type="info" :closable="false" show-icon class="mode-alert">
      <template #title>
        当前为待回货单，原出库单号：{{ sourceBillCode || '-' }}
      </template>
    </el-alert>

    <el-form :model="bill" label-width="100px" class="bill-form">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="流程类型">
            <el-select v-model="template" :disabled="!!id" @change="onTemplateChange">
              <el-option label="维修" value="repair"></el-option>
              <el-option label="融金" value="gold"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="结案方式">
            <el-select v-model="completionMode" :disabled="template == 'repair' || !!id" @change="onCompletionChange">
              <el-option label="回货入库" value="return"></el-option>
              <el-option label="回款结案" value="cash"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="单据编号">
            <el-input v-model="bill.billCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item :label="isReturnBill ? '待回货状态' : '出库单状态'">
            <el-tag :type="statusType(bill.status)">{{ statusText(bill.status) }}</el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="单据日期">
            <el-date-picker v-model="bill.billDate" type="date" value-format="YYYY-MM-DD" style="width:100%"
              :disabled="isLocked"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="所属公司">
            <el-tree-select v-model="bill.companyId" :data="companys" check-strictly :render-after-expand="false"
              :disabled="!!id || sourceDetails.length > 0" @change="onCompanyChange" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="渠道">
            <el-input v-model="bill.channelCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="申请人">
            <el-input v-model="bill.operatorName" :disabled="isLocked"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="bill.reason" :disabled="isLocked"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template v-if="isReturnBill && sourceBill">
      <el-divider content-position="left">出库单信息</el-divider>
      <el-descriptions border :column="4" size="small">
        <el-descriptions-item label="出库单号">{{ sourceBill.billCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="出库状态">
          <el-tag :type="statusType(sourceBill.status)">{{ statusText(sourceBill.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="库房">{{ sourceBill.storeCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="渠道">{{ sourceBill.channelCode || '-' }}</el-descriptions-item>
      </el-descriptions>
    </template>

    <el-divider content-position="left">出库明细</el-divider>
    <div class="table-toolbar" v-if="!id">
      <el-button type="primary" plain icon="Plus" @click="openAddDialog">添加出库货品</el-button>
      <el-button type="danger" plain icon="Delete" :disabled="sourceDetails.length === 0" @click="clearSourceDetails">清空明细</el-button>
    </div>
    <el-table :data="sourceDetails" stripe border size="small" style="width:100%;">
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column prop="sourceBillCode" label="出库原单号" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
      <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
      <el-table-column prop="stockNumber" label="出库数量" width="110">
        <template #default="scope">
          <el-input v-if="!id" type="number" v-model.number="scope.row.stockNumber"></el-input>
          <span v-else>{{ scope.row.stockNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stockRemain" label="可用数" width="90"></el-table-column>
      <el-table-column prop="weight" label="克重" width="90"></el-table-column>
      <el-table-column prop="goldWeight" label="金重" width="90"></el-table-column>
      <el-table-column prop="productPrice" label="成本" width="100"></el-table-column>
      <el-table-column v-if="!id" label="操作" width="80" align="center">
        <template #default="scope">
          <el-button type="primary" link size="small" @click="removeSource(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template v-if="outboundFlows.length > 0">
      <el-divider content-position="left">已出库流水</el-divider>
      <el-table :data="outboundFlows" stripe border size="small" style="width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="billCode" label="出库单号" width="140"></el-table-column>
        <el-table-column prop="billType" label="流水类型" width="120"></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130"></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockNumber" label="数量" width="90"></el-table-column>
        <el-table-column prop="stockReason" label="原因" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
    </template>

    <template v-if="isReturnBill">
      <template v-if="requiresReturn">
        <el-divider content-position="left">{{ template == 'repair' ? '维修回货入库' : '融金回货入库' }}</el-divider>
        <div class="table-toolbar">
          <el-button type="primary" plain icon="Plus" :disabled="!canEditCompletion" @click="addReturnLine">新增回货入库明细</el-button>
        </div>
        <el-table :data="returnDetails" stripe border size="small" style="width:100%;">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="storeCode" label="入库库房" width="130">
            <template #default="scope">
              <el-select v-model="scope.row.storeCode" :disabled="!canEditCompletion" style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="channel" label="入库渠道" width="130">
            <template #default="scope">
              <el-select v-model="scope.row.channel" :disabled="!canEditCompletion" style="width:100%">
                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="serialCode" label="回货批次号" width="150">
            <template #default="scope"><el-input v-model="scope.row.serialCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="detailCode" label="系统款号" width="130">
            <template #default="scope"><el-input v-model="scope.row.detailCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="brandModelCode" label="品牌款号" width="120">
            <template #default="scope"><el-input v-model="scope.row.brandModelCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="stockNumber" label="数量" width="90">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.stockNumber" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="weight" label="克重" width="100">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.weight" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldWeight" label="金重" width="100">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.goldWeight" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="productPrice" label="入库成本" width="120">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.productPrice" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180">
            <template #default="scope"><el-input v-model="scope.row.remark" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column v-if="canEditCompletion" label="操作" width="80" align="center">
            <template #default="scope">
              <el-button type="primary" link size="small" @click="removeDetailLine(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-else>
        <el-divider content-position="left">融金回款结案</el-divider>
        <div class="table-toolbar">
          <el-button type="primary" plain icon="Plus" :disabled="!canEditCompletion" @click="addSettlementLine">新增回款记录</el-button>
        </div>
        <el-table :data="settlementDetails" stripe border size="small" style="width:100%;">
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="serialCode" label="关联批次号" width="140">
            <template #default="scope"><el-input v-model="scope.row.serialCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="storeCode" label="库房" width="110">
            <template #default="scope"><el-input v-model="scope.row.storeCode" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="channel" label="渠道" width="110">
            <template #default="scope"><el-input v-model="scope.row.channel" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="weight" label="融金克重" width="120">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.weight" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="goldWeight" label="融金金重" width="120">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.goldWeight" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="productPrice" label="回款金额" width="130">
            <template #default="scope"><el-input type="number" v-model.number="scope.row.productPrice" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180">
            <template #default="scope"><el-input v-model="scope.row.remark" :disabled="!canEditCompletion"></el-input></template>
          </el-table-column>
          <el-table-column v-if="canEditCompletion" label="操作" width="80" align="center">
            <template #default="scope">
              <el-button type="primary" link size="small" @click="removeDetailLine(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>

    <div class="actions">
      <el-button v-if="!id" type="primary" icon="Promotion" @click="submitCreate">提交出库申请</el-button>
      <el-button v-if="isReturnBill && canEditCompletion" type="primary" plain icon="DocumentChecked" @click="saveCompletion">保存待回货明细</el-button>
      <el-button v-if="id && bill.status == 0" type="primary" icon="Check" @click="approveStage">{{ isReturnBill ? '待回货确认' : '负责人审核' }}</el-button>
      <el-button v-if="id && bill.status == 11" type="warning" icon="EditPen" @click="reviewStage">
        {{ template == 'gold' ? '财务复核' : '成本复核' }}
      </el-button>
      <el-button v-if="id && bill.status == 21" type="success" icon="Finished" @click="auditStage">{{ isReturnBill ? '完成待回货' : '库管审核出库' }}</el-button>
      <el-button v-if="id && !isReturnBill && bill.status == 1" type="success" icon="Tickets" @click="openReturnBill">打开待回货单</el-button>
      <el-button v-if="id && bill.status == 1" type="success" plain icon="Tickets" @click="openStockDetail">库存明细</el-button>
      <el-button @click="$router.push('/stock/bills/pendingReturn')">返回</el-button>
    </div>

    <el-dialog title="添加出库货品" v-model="showAddDialog" style="max-width:1200px; width:100%;" destroy-on-close>
      <el-form :model="searchForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="所属公司">
              <el-tree-select v-model="bill.companyId" :data="companys" check-strictly :render-after-expand="false"
                style="width:100%" :disabled="sourceDetails.length > 0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="批次号">
              <el-input v-model="searchForm.serialCode" clearable @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="系统款号">
              <el-input v-model="searchForm.detailCode" clearable @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="品牌款号">
              <el-input v-model="searchForm.brandModelCode" clearable @keyup.enter="searchSource"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="库房">
              <el-select v-model="searchForm.storeCode" clearable placeholder="全部库房" style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="渠道">
              <el-select v-model="searchForm.channel" clearable placeholder="全部渠道" style="width:100%">
                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label || item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-actions">
          <el-button type="primary" icon="Search" :loading="searchLoading" @click="searchSource">查询货品</el-button>
          <el-button @click="resetSearchForm">重置</el-button>
          <el-button type="success" icon="Plus" :disabled="searchSelectedItems.length === 0" @click="batchAddSource">批量添加 ({{ searchSelectedItems.length }})</el-button>
        </div>
      </el-form>

      <el-divider></el-divider>
      <el-table :data="sourceResults" border size="small" max-height="420" v-loading="searchLoading"
        @selection-change="handleSearchSelectionChange" style="width:100%;">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="billCode" label="库存单号" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailName" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="90"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="90"></el-table-column>
        <el-table-column prop="stockRemain" label="可用数" width="90"></el-table-column>
        <el-table-column prop="weight" label="克重" width="90"></el-table-column>
        <el-table-column prop="goldWeight" label="金重" width="90"></el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="showAddDialog = false">关闭</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  fetchBillCode,
  fetchGroupBySerialCode,
  fetchPendingReturnDetail,
  submitPendingReturn,
  approvePendingReturn,
  reviewPendingReturn,
  savePendingReturnCompletion,
  auditPendingReturn
} from "@/api/stock";

export default {
  name: "PendingReturnDetail",
  data() {
    return {
      id: "",
      template: "repair",
      completionMode: "return",
      bill: {},
      sourceBill: null,
      details: [],
      sourcePrebounds: [],
      sourceBounds: [],
      bounds: [],
      showAddDialog: false,
      searchForm: {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: ""
      },
      sourceResults: [],
      searchSelectedItems: [],
      searchLoading: false,
      companys: [],
      dict: {
        stores: [],
        channels: []
      }
    };
  },
  computed: {
    isReturnBill() {
      return (this.bill.billCode || this.id || "").endsWith("-R");
    },
    isLocked() {
      return !!this.id;
    },
    canEditCompletion() {
      return this.isReturnBill && this.bill.status != 1 && this.bill.status != -1;
    },
    requiresReturn() {
      return this.completionMode == "return";
    },
    sourceBillCode() {
      return this.sourceBill?.billCode || (this.isReturnBill ? (this.bill.netCode || (this.bill.billCode || "").replace(/-R$/, "")) : this.bill.billCode);
    },
    sourceDetails() {
      if (this.isReturnBill) {
        return this.sourcePrebounds.length > 0 ? this.sourcePrebounds : this.sourceBounds;
      }
      return this.details.filter(item => item.processLineType == "source-out");
    },
    returnDetails() {
      return this.details.filter(item => item.processLineType == "return-in");
    },
    settlementDetails() {
      return this.details.filter(item => item.processLineType == "settlement");
    },
    completionDetails() {
      return this.requiresReturn ? this.returnDetails : this.settlementDetails;
    },
    outboundFlows() {
      if (this.isReturnBill) return this.sourceBounds;
      return this.bounds.filter(item => Number(item.stockNumber || 0) < 0);
    }
  },
  created() {
    this.id = this.$route.query.id || "";
    this.template = this.$route.query.template || "repair";
    this.completionMode = this.template == "gold" ? "cash" : "return";
    this.initBill();
    if (this.id) {
      this.loadDetail();
    } else {
      this.initBillCode();
    }
  },
  mounted() {
    this.$kaung.companys().then((res) => {
      this.companys = res || [];
      if (!this.bill.companyId && this.companys.length > 0) {
        this.bill.companyId = this.$store.getters.getUserInfo?.companyID || this.companys[0].id;
      }
    });
    this.$kaung.dictionary("stock", "store").then(res => this.dict.stores = res || []);
    this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res || []);
  },
  methods: {
    initBill() {
      const user = this.$store.getters.getUserInfo || {};
      this.bill = {
        billType: "待回货流程",
        billSource: this.template + ":" + this.completionMode,
        billCode: "",
        billDate: this.$util.fmtDate(new Date(), "yyyy-MM-dd"),
        companyId: user.companyID || "",
        operatorName: user.realName || user.name || "",
        createUserName: user.realName || user.name || "",
        status: 0,
        reason: ""
      };
    },
    initBillCode() {
      fetchBillCode({ billType: "待回货流程", prev: this.template == "gold" ? "DHH-RJ" : "DHH-WX" }).then((res) => {
        this.bill.billCode = res.data;
      });
    },
    loadDetail() {
      fetchPendingReturnDetail(this.id).then((res) => {
        const data = res.data || {};
        this.bill = data.bill || {};
        this.bill.companyId = this.bill.companyId || this.bill.companyID || "";
        this.sourceBill = data.sourceBill || null;
        this.template = data.template || this.sourceTemplate(this.bill.billSource);
        this.completionMode = data.completionMode || this.sourceMode(this.bill.billSource);
        this.details = data.prebounds || [];
        this.bounds = data.bounds || [];
        this.sourcePrebounds = data.sourcePrebounds || [];
        this.sourceBounds = data.sourceBounds || [];
      });
    },
    onTemplateChange() {
      this.completionMode = this.template == "gold" ? "cash" : "return";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.clearPendingData();
      this.initBillCode();
    },
    onCompletionChange() {
      if (this.template == "repair") this.completionMode = "return";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.clearPendingData();
    },
    onCompanyChange() {
      if (!this.id) this.clearPendingData();
    },
    clearPendingData() {
      this.details = [];
      this.sourceResults = [];
      this.searchSelectedItems = [];
      this.bill.channelCode = "";
      this.bill.storeCode = "";
      this.bill.netCode = "";
    },
    openAddDialog() {
      if (!this.currentCompanyId()) {
        this.$message({ type: "warning", message: "请选择所属公司" });
        return;
      }
      this.showAddDialog = true;
      this.resetSearchForm();
    },
    resetSearchForm() {
      this.searchForm = { serialCode: "", detailCode: "", brandModelCode: "", storeCode: "", channel: "" };
      this.sourceResults = [];
      this.searchSelectedItems = [];
    },
    searchSource() {
      if (!this.currentCompanyId()) {
        this.$message({ type: "warning", message: "请选择所属公司" });
        return;
      }
      if (!this.searchForm.serialCode && !this.searchForm.detailCode && !this.searchForm.brandModelCode && !this.searchForm.storeCode && !this.searchForm.channel) {
        this.$message({ type: "warning", message: "请至少填写一个查询条件" });
        return;
      }

      const serialCodes = this.searchForm.serialCode
        ? this.searchForm.serialCode.split(",").map(item => item.trim()).filter(item => item)
        : [];
      this.searchLoading = true;
      fetchGroupBySerialCode(
        serialCodes,
        this.currentCompanyId(),
        this.searchForm.detailCode || "",
        this.searchForm.storeCode || "",
        this.searchForm.channel || "",
        this.searchForm.brandModelCode || ""
      ).then((res) => {
        this.searchLoading = false;
        if (res.code == 200) {
          this.sourceResults = (res.data || []).filter(item => Number(item.stockRemain || 0) > 0);
        } else {
          this.$message({ type: "warning", message: res.content || "查询失败" });
        }
      }).catch(() => {
        this.searchLoading = false;
        this.$message({ type: "error", message: "查询失败" });
      });
    },
    handleSearchSelectionChange(selection) {
      this.searchSelectedItems = selection || [];
    },
    batchAddSource() {
      let added = 0;
      let duplicate = 0;
      this.searchSelectedItems.forEach((item) => {
        const sourceId = item.id || item.ID || "";
        if (!sourceId || this.sourceDetails.some(row => (row.originalID || row.originalId || row.id) == sourceId)) {
          duplicate += 1;
          return;
        }
        this.details.push(this.copySourceDetail(item));
        added += 1;
      });
      this.syncBillLocationFields();
      this.searchSelectedItems = [];
      if (added > 0) this.$message({ type: "success", message: `成功添加 ${added} 条货品` });
      if (added == 0 && duplicate > 0) this.$message({ type: "warning", message: "所选货品已在出库明细中" });
    },
    copySourceDetail(row) {
      const stockNumber = Number(row.stockRemain || 1);
      return {
        ...row,
        id: row.id || row.ID,
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: row.companyID || row.companyId || this.currentCompanyId(),
        companyID: row.companyID || row.companyId || this.currentCompanyId(),
        originalID: row.id || row.ID,
        originalId: row.id || row.ID,
        sourceBillCode: row.sourceBillCode || row.billCode,
        processLineType: "source-out",
        stockNumber: stockNumber,
        stockRemain: stockNumber,
        storeName: row.storeCode,
        status: "0"
      };
    },
    buildReturnLine() {
      const source = this.sourceDetails[0] || {};
      return {
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: this.currentCompanyId(),
        companyID: this.currentCompanyId(),
        processLineType: "return-in",
        sourceBillCode: this.sourceBillCode,
        originalID: source.originalID || source.originalId || source.id || "",
        detailCode: source.detailCode || "",
        detailName: source.detailName || "",
        brandCode: source.brandCode || "",
        brandName: source.brandName || "",
        brandModelCode: source.brandModelCode || "",
        unitName: source.unitName || "",
        storeCode: this.defaultStoreCode(),
        storeName: this.defaultStoreCode(),
        channel: this.defaultChannel(),
        stockNumber: 1,
        stockRemain: 1,
        stockStatus: "available",
        remark: this.template == "gold" ? "融金回货入库" : "维修回货入库",
        status: "0"
      };
    },
    buildSettlementLine() {
      const source = this.sourceDetails[0] || {};
      return {
        billCode: this.bill.billCode,
        billType: this.bill.billType,
        companyId: this.currentCompanyId(),
        companyID: this.currentCompanyId(),
        processLineType: "settlement",
        sourceBillCode: this.sourceBillCode,
        originalID: source.originalID || source.originalId || source.id || "",
        detailCode: source.detailCode || "",
        detailName: source.detailName || "",
        serialCode: source.serialCode || "",
        storeCode: source.storeCode || "",
        channel: source.channel || "",
        stockNumber: 0,
        stockRemain: 0,
        remark: "融金回款结案",
        status: "0"
      };
    },
    addReturnLine() {
      this.details.push(this.buildReturnLine());
    },
    addSettlementLine() {
      this.details.push(this.buildSettlementLine());
    },
    removeDetailLine(row) {
      this.details = this.details.filter(item => item !== row);
    },
    removeSource(row) {
      this.details = this.details.filter(item => item !== row);
      this.syncBillLocationFields();
    },
    clearSourceDetails() {
      this.details = this.details.filter(item => item.processLineType != "source-out");
      this.syncBillLocationFields();
    },
    validateCreate() {
      if (!this.currentCompanyId()) return "请选择所属公司";
      if (this.sourceDetails.length == 0) return "请先添加出库货品";
      const invalid = this.sourceDetails.find(item => !item.stockNumber || Number(item.stockNumber) <= 0);
      if (invalid) return "出库数量必须大于0";
      return "";
    },
    validateCompletion() {
      if (!this.isReturnBill) return "";
      if (this.requiresReturn && this.returnDetails.length == 0) return "请维护回货入库明细";
      if (!this.requiresReturn && this.settlementDetails.length == 0) return "请维护回款记录";
      return "";
    },
    recalcBill() {
      this.bill.billType = "待回货流程";
      this.bill.billSource = this.template + ":" + this.completionMode;
      this.bill.companyId = this.currentCompanyId();
      this.bill.companyID = this.currentCompanyId();
      const rows = this.isReturnBill ? this.completionDetails : this.sourceDetails;
      this.bill.productNumber = rows.reduce((sum, item) => sum + Number(item.stockNumber || 0), 0);
      this.bill.costTotal = rows.reduce((sum, item) => sum + Number(item.productPrice || 0) * Math.abs(Number(item.stockNumber || 1)), 0);
      this.bill.goldWeightTotal = rows.reduce((sum, item) => sum + Number(item.goldWeight || 0) * Math.abs(Number(item.stockNumber || 1)), 0);
      this.syncBillLocationFields();
    },
    syncBillLocationFields() {
      const rows = this.sourceDetails;
      this.bill.storeCode = this.distinctText(rows.map(item => item.storeCode));
      this.bill.channelCode = this.distinctText(rows.map(item => item.channel));
      if (!this.isReturnBill) this.bill.netCode = this.distinctText(rows.map(item => item.sourceBillCode || item.billCode));
    },
    currentCompanyId() {
      return this.bill.companyId || this.bill.companyID || "";
    },
    distinctText(values) {
      return [...new Set((values || []).filter(item => item && item.length > 0))].join(";");
    },
    defaultStoreCode() {
      return this.dict.stores[0]?.value || this.dict.stores[0]?.name || "成品库";
    },
    defaultChannel() {
      return this.dict.channels[0]?.value || this.dict.channels[0]?.name || "";
    },
    payload() {
      this.recalcBill();
      return { bill: this.bill, details: this.sourceDetails, template: this.template, completionMode: this.completionMode };
    },
    submitCreate() {
      const msg = this.validateCreate();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }
      submitPendingReturn(this.payload()).then((res) => this.afterAction(res, true));
    },
    saveCompletion() {
      const msg = this.validateCompletion();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return Promise.resolve(false);
      }
      this.recalcBill();
      return savePendingReturnCompletion(this.id, this.completionDetails).then((res) => {
        this.afterAction(res, false);
        return res.code == 200;
      });
    },
    approveStage() {
      const before = this.isReturnBill ? this.saveCompletion() : Promise.resolve(true);
      before.then((ok) => {
        if (ok !== false) approvePendingReturn(this.id).then((res) => this.afterAction(res));
      });
    },
    reviewStage() {
      const details = this.isReturnBill ? this.completionDetails : this.sourceDetails;
      if (this.isReturnBill) {
        const msg = this.validateCompletion();
        if (msg) {
          this.$message({ type: "warning", message: msg });
          return;
        }
      }
      reviewPendingReturn(this.id, details).then((res) => this.afterAction(res));
    },
    auditStage() {
      auditPendingReturn(this.id).then((res) => this.afterAction(res, true));
    },
    afterAction(res, back) {
      this.$notify({
        title: res.code == 200 ? "操作成功" : "操作失败",
        message: res.content,
        type: res.type,
        duration: 10000
      });
      if (res.code == 200) {
        if (back) {
          this.$router.push("/stock/bills/pendingReturn");
        } else {
          this.loadDetail();
        }
      }
    },
    openStockDetail() {
      const billCode = this.isReturnBill ? this.bill.billCode : this.bill.billCode;
      this.$router.push({ path: "/stock/bills/detail", query: { billCode } });
    },
    openReturnBill() {
      this.$router.push({ path: "/stock/bills/pendingReturnDetail", query: { id: this.bill.netCode || `${this.bill.billCode}-R`, template: this.template } });
    },
    sourceTemplate(value) {
      return (value || "").split(":")[0] || "repair";
    },
    sourceMode(value) {
      return (value || "").split(":")[1] || (this.sourceTemplate(value) == "gold" ? "cash" : "return");
    },
    statusText(status) {
      const map = { 0: "待负责人审核", 11: this.template == "gold" ? "待财务复核" : "待成本复核", 21: "待库管审核", 1: "已完成", "-1": "已取消" };
      return map[status] || "草稿";
    },
    statusType(status) {
      const map = { 0: "", 11: "warning", 21: "warning", 1: "success", "-1": "danger" };
      return map[status] || "info";
    }
  }
};
</script>

<style scoped>
.mode-alert {
  margin-bottom: 12px;
}

.table-toolbar {
  margin: 8px 0 12px;
}

.dialog-actions {
  text-align: center;
}

.actions {
  margin-top: 18px;
  text-align: right;
}
</style>
